import React from 'react';
import clsx from 'clsx';

import ProbabilityBar from '../../../../DebtProducts/components/ProbabilityBar/ProbabilityBar';
import debtProductsStyles from '../../../../DebtProducts/DebtProducts.module.scss';
import { ctaGrey } from '../../../../../assets/hostedassets';
import styles from './DealProbabilityCell.module.scss';

type Props = {
    /** Raw value for the bar (from `getOptionProbabilityForDisplay`). */
    optionProbability?: number | null;
    pecThreshold?: string;
    /** Resolved id for GET getDealProbability; when missing, cell is read-only. */
    referenceId?: string | null;
    onOpen: (referenceId: string) => void;
};

function DealProbabilityCell({ optionProbability, pecThreshold, referenceId, onOpen }: Props) {
    const probForBar =
        optionProbability != null && !Number.isNaN(Number(optionProbability)) ? String(Math.round(Number(optionProbability))) : '0';

    const canOpen = !!referenceId;

    return (
        <div
            className={clsx(debtProductsStyles.ProbabilityRow, styles.Wrapper, {
                [styles.Clickable]: canOpen,
                [styles.ReadOnly]: !canOpen,
            })}
            onClick={(e) => {
                // Stop row <tr> click (expand/collapse + deal terms) from firing when interacting with this cell.
                e.stopPropagation();
                if (!canOpen) return;
                onOpen(referenceId as string);
            }}
        >
            <ProbabilityBar probability={probForBar} pecThreshold={pecThreshold} />
            <img src={ctaGrey} alt="" height={12} className={clsx({ [styles.ChevronMuted]: !canOpen })} />
        </div>
    );
}

export default DealProbabilityCell;
